// extracted by mini-css-extract-plugin
export default {"btn":"DropdownMenu_btn__o3BIt","menu":"DropdownMenu_menu__-Ou75","menu__paper":"DropdownMenu_menu__paper__DrnNh"};